module.exports = __webpack_public_path__ + "static/media/spanish_restaurant_initial_mural_concept_2018.2fbf1347.webp";